

import { ModelSelect, ModelListSelect  } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'





import UMUM from         '../../library/umum'
import FETCHING from  '../../library/fetching'
import FUNCTIONS from  '../../library/function'

export default {
  components: {
     ModelSelect, ModelListSelect,  
  },
  data() {
    return {
      

      form : {
        id : '',
        bentuk : '',
        sifat : '',
        type : 0,
        judul : '',
        perihal : '',
        nomor : '',
        konseptor : '',
        unit_kerja : '',
        penanda_tangan : '',
        status_ttd : '',
        tgl_ttd : '',
        isi : '',
        keterangan : '',
        lampiran : null,
        lampiran_type : '',
        pengagenda : '',
        status_agenda : '',
        tgl_agenda : '',
        status : '',

        pemeriksa_id : '',
        pemeriksa_status : 0,
        pemeriksa_unit_pemeriksa : '',
        pemeriksa_keterangan: '',
        pemeriksa_unit_kerja_uraian : '',

        user_nama : ''
      },

      borang_template :'',
     
      list_data : [],
      list_penandatangan : [],
      list_pemeriksa : [],
      list_penerima : [],

      list_penerima_final : [],

      filterku : {
        instansi_id : '',
        unit_kerja_id : '',
        unit_kerja_search : '',
        biodata_id :null,
        status_id : '',
      },


      page_first: 1,
      page_last: 0,
      page_limit : 10,
      cari_value: "",
      cek_load_data : true,



      mdl_fileLampiran: false,
      mdl_viewPenerima: false,
      mdl_viewPemeriksa: false,
      mdl_viewPPenandaTangan: false,

      ambil_semua_unit_kerja : false,

      mdl_kembalikan : false,

      UMUM : UMUM,
      FETCHING : FETCHING,
      FUNCTIONS : FUNCTIONS,

      fileOld : '',

      step: 1,

      content: 'asdas',
    }
  },
  methods: {


    insertTable(){
      let tableModule = this.$refs.myQuillEditor.quill.getModule('better-table')
      tableModule.insertTable(3, 3)
    },


    getView : function(){
      // this.$store.commit("shoWLoading");
      this.cek_load_data = true;
      fetch(this.$store.state.url.office_sk_verifikasiSurat + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value,
              unit_kerja : this.form.unit_kerja,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              // this.$store.commit("hideLoading");
              this.cek_load_data = false;
              console.log(res_data);
      });
    },

    koreksiSurat : function(){
      fetch(this.$store.state.url.office_sk_verifikasiSurat + "koreksi", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
            this.Notify('Sukses Memperbaharui Surat', 'primary', 'check_circle_outline');
            this.getView()
      });
    },


    approveSurat : async function(){

      await UMUM.approveSweetAlert('Untuk melakukan approve pada surat ini?')

      fetch(this.$store.state.url.office_sk_verifikasiSurat + "approve", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
            this.Notify('Sukses Memperbaharui Surat', 'primary', 'check_circle_outline');
            this.getView()
      });
    },


    selectData : function(data){
        this.form.id = data.id
        this.form.bentuk = data.bentuk
        this.form.sifat = data.sifat
        this.form.type = data.type
        this.form.judul = data.judul
        this.form.perihal = data.perihal
        this.form.nomor = data.nomor
        this.form.konseptor = data.konseptor
        this.form.unit_kerja = data.unit_kerja
        this.form.penanda_tangan = data.penanda_tangan
        this.form.status_ttd = data.status_ttd
        this.form.tgl_ttd = data.tgl_ttd
        this.form.isi = data.isi
        this.form.keterangan = data.keterangan
        // this.form.lampiran = data.lampiran
        this.fileOld = data.lampiran

        this.form.lampiran_type = data.lampiran_type
        this.form.pengagenda = data.pengagenda
        this.form.status_agenda = data.status_agenda
        this.form.tgl_agenda = data.tgl_agenda
        this.form.status = data.status

        this.form.pemeriksa_id = data.pemeriksa_id
        this.form.pemeriksa_status = data.pemeriksa_status
        this.form.pemeriksa_keterangan = data.pemeriksa_keterangan
        this.form.pemeriksa_unit_kerja_uraian = data.pemeriksa_unit_kerja_uraian
        this.form.pemeriksa_unit_pemeriksa = data.pemeriksa_unit_pemeriksa
        this.form.user_nama = UMUM.namaLengkap(data.biodata_gelar_depan, data.biodata_nama, data.biodata_gelar_belakang);

        this.asyncFunc(data.id)
    },


    searchUnitKerja : function(){
      this.FETCHING.postUnitKerjaSearch(this.filterku.unit_kerja_search)
    },

    asyncFunc : async function(surat_id){
      this.list_pemeriksa = await this.FETCHING.postOnePemeriksa(surat_id);
      this.list_penandatangan = await this.FETCHING.postOnepenandaTangan(surat_id);
      this.list_penerima_final = await this.FETCHING.postOnePenerima(surat_id);
    },


    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        

    // ====================================== PAGINATE ====================================







  },

  mounted () {

    var get_profile = JSON.parse(localStorage.profile);
    this.form.unit_kerja = get_profile.profile.unit_kerja;

    this.FETCHING.getBentuk();
    this.FETCHING.getSifat();
    this.FETCHING.getBorang();

    this.FETCHING.postUnitKerjaAuto('')
    this.FETCHING.postBiodataAuto('','')

    this.getView();

  },
}
